import { render, staticRenderFns } from "./AdminGroups.vue?vue&type=template&id=73f724f0"
import script from "./AdminGroups.vue?vue&type=script&lang=js"
export * from "./AdminGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f724f0')) {
      api.createRecord('73f724f0', component.options)
    } else {
      api.reload('73f724f0', component.options)
    }
    module.hot.accept("./AdminGroups.vue?vue&type=template&id=73f724f0", function () {
      api.rerender('73f724f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admins/AdminGroups.vue"
export default component.exports